import React from "react";
import { motion } from "framer-motion";
import { Coins, Share2, Globe } from "lucide-react";

const POINTS = [
  {
    icon: Coins,
    title: "Fair Pay, Zero Disruption",
    desc: "We don't compete with salons, we complement them. Stylists monetise their downtime with digital consultations, creating a new income stream without hurting floor revenue.",
  },
  {
    icon: Share2,
    title: "Earn Through Our Affiliate Ecosystem",
    desc: "Salons, stylists and influencers earn additional recurring capital simply by introducing Senior Stylist to their audiences and clients.",
  },
  {
    icon: Globe,
    title: "True Global Inclusion",
    desc: "Powered by our Style DNA Matrix, we're bringing tailored fashion, hair and beauty directly to your phone, making expert styling accessible to anyone, anywhere on the globe.",
  },
];

export const About = () => {
  return (
    <section id="about" className="py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-4 sm:px-8 lg:px-16">
        <div className="max-w-2xl">
          <span className="eyebrow">About us</span>
          <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl text-stylist-ink">
            Why Senior Stylist?
          </h2>
          <p className="mt-6 text-base md:text-lg text-stylist-ink2 leading-relaxed">
            Personal styling shouldn't be an elite luxury, and talented professionals shouldn't be
            underpaid. We're using technology to level the playing field for both sides.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {POINTS.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="bg-white border border-stylist-border rounded-lg p-7 hover:border-stylist-gold/40 hover:shadow-xl transition-all duration-500"
              data-testid={`about-point-${i}`}
            >
              <div className="w-11 h-11 rounded-full bg-stylist-gold/15 flex items-center justify-center">
                <p.icon className="w-5 h-5 text-stylist-gold" />
              </div>
              <h3 className="mt-4 font-serif text-xl text-stylist-ink leading-snug">{p.title}</h3>
              <p className="mt-3 text-sm text-stylist-ink2 leading-relaxed">{p.desc}</p>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mt-14 text-center font-serif text-2xl md:text-3xl italic text-stylist-ink"
        >
          Styling is for everyone. <span className="text-stylist-gold">Our job is access.</span>
        </motion.p>
      </div>
    </section>
  );
};
